import axios from 'axios'
import store from '@/store'
export const LoginApi = '/echo/rest/api/v2/auth/login'
export const ResetPassApi = '/echo/rest/api/v2/auth/forgot-password'
export const ProjectsApi = '/echo/rest/api/v2/projects'
export const TasksApi = '/echo/rest/api/v2/tasks'
export const AnnouncmentsApi = '/echo/rest/api/v2/campaigns/announcements/'
export const EventsApi = '/echo/rest/api/v2/events?from_dateTime='
export const refreshApi = '/echo/rest/api/v2/auth/refresh-token'
export const SubsApi = '/echo/rest/api/v2/subs'
export const FilesApi = '/echo/rest/api/v2/files'
export const FileUploadApi = '/echo/rest/api/v2/files/save'
export const OrdersApi = '/echo/rest/api/v2/orders'
export const TicketsApi = '/echo/rest/api/v2/tickets'
export const ThreadsApi = '/echo/rest/api/v2/tickets/thread'
export const ThreadEditApi = '/echo/rest/api/v2/tickets/thread/update' // Thread content edit (update)
export const CommApi = '/echo/rest/api/v2/comm'
export const AvatarApi = '/echo/files/avatars/'
export const LogsApi = '/echo/rest/api/v2/logs'
export const LogoutLogApi = '/echo/rest/api/v2/logs/logout'
export const ActivitiesApi = '/echo/rest/api/v2/activities'
export const TransactionsApi = '/echo/rest/api/v2/transactions'
export const InvoicesApi = '/echo/rest/api/v2/invoices'
export const InvoicePdfApi = '/echo/rest/api/v2/invoices/pdf'
export const UserApi = '/echo/rest/api/v2/me'
export const TranslationsApi = '/echo/rest/api/v2/translations?account_id=1'
export const PagesApi = '/echo/rest/api/v2/pages'
export const EmployeesApi = '/echo/rest/api/v2/employees'
export const CompanyDetailsApi = '/echo/rest/api/v2/company/details/'
export const TicketTypeApi = '/echo/rest/api/v2/tickets/type'
export const UsersApi = '/echo/rest/api/v2/users'
export const ReniewSubApi = '/echo/rest/api/v2/subs/updateSubscription'

export const getHeader = function () {
  const tokenData = JSON.parse(atob(localStorage.getItem('authUser')))
  // const tokenData = store.state.data.tokenData
  // const tokenData = store.getters.isAuthenticated
  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + tokenData.access_token
  }
  return headers
}

export const getHeaderRefresh = function () {
  // const tokenData = JSON.parse(atob(localStorage.getItem('authUser')))
  const tokenData = store.state.data.tokenData
  // const tokenData = store.getters.isAuthenticated
  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + tokenData.refresh_token
  }
  return headers
}

export const refreshToken = function () {
  var refToken = JSON.parse(atob(localStorage.getItem('authUser')))
  refToken = refToken.refresh_token
  return new Promise((resolve, reject) => {
    axios.post('https://' + store.state.data.hostname + refreshApi, null, { headers: getHeaderRefresh() })
      .then(function (response) {
      // handle success
        // console.log(response)
        const authUser = {}
        authUser.access_token = response.data.access_token
        authUser.refresh_token = refToken
        // localStorage.setItem('authUser', JSON.stringify(authUser))
        localStorage.setItem('authUser', btoa(JSON.stringify(authUser)))
        store.state.data.tokenData = authUser
        resolve()
        // window.location.reload()
      })
      .catch(function (error) {
      // handle error
        // console.log(error)
        if (error.response.status === 401) {
          localStorage.removeItem('authUser')
          localStorage.removeItem('authBUser')
          store.state.data.tokenData = ''
          window.location.href = '/'
        }
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/echoApi.js